var _defs, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAvatar16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_50_Kids_Icons-39",
    "data-name": "50_Kids_Icons-39",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1428",
    "data-name": "Path 1428",
    d: "M0,40A40,40,0,1,1,40,80,40,40,0,0,1,0,40Z",
    fill: "#2961a5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4784",
    "data-name": "Group 4784"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1429",
    "data-name": "Path 1429",
    d: "M159.781,246.492c1.025,2.428.467,4.787-1.247,5.27s-3.933-1.093-4.958-3.521-.467-4.787,1.247-5.27S158.756,244.065,159.781,246.492Z",
    transform: "translate(-129.147 -204.934)",
    fill: "#f0b39c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M326.834,246.492c-1.025,2.428-.467,4.787,1.247,5.27s3.933-1.093,4.958-3.521.467-4.787-1.247-5.27S327.859,244.065,326.834,246.492Z",
    transform: "translate(-275.333 -204.934)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M135.233,412.258l-.008-.132c0-8-2.995-15.753-6.652-17.229L113,388.623a20.633,20.633,0,0,0-13.3-.017l-15.8,6.312c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132Z",
    transform: "translate(-65.164 -326.964)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4770",
    "data-name": "Group 4770",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1434",
    "data-name": "Path 1434",
    d: "M233.813,277.007a6.219,6.219,0,0,1-6.219,6.219h-.754a6.219,6.219,0,0,1-6.219-6.219V260.989a6.219,6.219,0,0,1,6.219-6.219h.754a6.219,6.219,0,0,1,6.219,6.219Z",
    transform: "translate(-186.15 -214.962)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4772",
    "data-name": "Group 4772",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4771",
    "data-name": "Group 4771",
    transform: "translate(27.685 18.107)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1436",
    "data-name": "Path 1436",
    d: "M203.948,143.36a10.422,10.422,0,0,1-10.423,10.422H187.6a10.422,10.422,0,0,1-10.422-10.422V126.306A10.422,10.422,0,0,1,187.6,115.884h5.923a10.422,10.422,0,0,1,10.423,10.422Z",
    transform: "translate(-177.181 -115.884)",
    fill: "#ffdbc5"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4773",
    "data-name": "Group 4773",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_257",
    "data-name": "Ellipse 257",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(34.389 40.012)",
    fill: "#3d2a3d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_258",
    "data-name": "Ellipse 258",
    cx: 1.548,
    cy: 1.548,
    r: 1.548,
    transform: "translate(44.652 40.012)",
    fill: "#3d2a3d"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4774",
    "data-name": "Group 4774",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1439",
    "data-name": "Path 1439",
    d: "M168.059,144.754l.609-5.347a5.61,5.61,0,0,1,5.574-4.975h13.215a5.61,5.61,0,0,1,5.574,4.974l.61,5.348h1.534a18.87,18.87,0,0,0,.857-5.65c0-9.4-6.8-17.029-15.182-17.029S165.668,129.7,165.668,139.1a18.865,18.865,0,0,0,.857,5.65h1.534Z",
    transform: "translate(-139.782 -103.002)",
    fill: "#e36849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4775",
    "data-name": "Group 4775",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1441",
    "data-name": "Path 1441",
    d: "M251.265,279.542a2.384,2.384,0,0,1-4.653.538,2.526,2.526,0,0,0-.114.71,2.553,2.553,0,1,0,5.105,0A2.517,2.517,0,0,0,251.265,279.542Z",
    transform: "translate(-207.983 -235.864)",
    fill: "#f0b39c"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4776",
    "data-name": "Group 4776",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M135.225,425.067c0-8-2.995-15.753-6.652-17.229l-12.384-4.989A10.937,10.937,0,0,1,96.3,402.9l-12.4,4.956c-3.66,1.465-6.655,9.208-6.655,17.209l-.008.132h58Z",
    transform: "translate(-65.165 -339.904)",
    fill: "#78bede"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4777",
    "data-name": "Group 4777",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_259",
    "data-name": "Ellipse 259",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(46.537 43.107)",
    fill: "#eb987f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_260",
    "data-name": "Ellipse 260",
    cx: 3.125,
    cy: 2.344,
    rx: 3.125,
    ry: 2.344,
    transform: "translate(29.349 43.107)",
    fill: "#eb987f"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4778",
    "data-name": "Group 4778",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1446",
    "data-name": "Path 1446",
    d: "M236.346,310.367a4.883,4.883,0,0,1-6.487,0c-1.231-1.159-3.091.694-1.856,1.856a7.56,7.56,0,0,0,10.2,0c1.235-1.163-.625-3.015-1.856-1.856Z",
    transform: "translate(-192.035 -261.563)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4781",
    "data-name": "Group 4781",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4779",
    "data-name": "Group 4779",
    transform: "translate(31.346 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1448",
    "data-name": "Path 1448",
    d: "M202.214,228.983a9.168,9.168,0,0,1,4.327-.877,1.053,1.053,0,0,0,0-2.105,11.422,11.422,0,0,0-5.39,1.165c-1.215.607-.148,2.423,1.062,1.818Z",
    transform: "translate(-200.615 -225.997)",
    fill: "#e36849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4780",
    "data-name": "Group 4780",
    transform: "translate(43.846 35.312)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1449",
    "data-name": "Path 1449",
    d: "M285.96,228.983a9.168,9.168,0,0,0-4.327-.877,1.053,1.053,0,0,1,0-2.105,11.423,11.423,0,0,1,5.39,1.165c1.215.607.148,2.423-1.062,1.818Z",
    transform: "translate(-280.615 -225.997)",
    fill: "#e36849"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4782",
    "data-name": "Group 4782",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1451",
    "data-name": "Path 1451",
    d: "M338.56,166.4l1.844.021.056-16.026-3.8-2.641Z",
    transform: "translate(-284.057 -124.665)",
    fill: "#e36849"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1452",
    "data-name": "Path 1452",
    d: "M164.711,166.012l1.843.02,2.035-18.6-3.9,2.555Z",
    transform: "translate(-138.952 -124.394)",
    fill: "#e36849"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4783",
    "data-name": "Group 4783",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_261",
    "data-name": "Ellipse 261",
    cx: 5.781,
    cy: 5.781,
    r: 5.781,
    transform: "translate(27.552 15.451)",
    fill: "#cf2e27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_262",
    "data-name": "Ellipse 262",
    cx: 6.406,
    cy: 6.406,
    r: 6.406,
    transform: "translate(35.208 13.419)",
    fill: "#cf2e27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_263",
    "data-name": "Ellipse 263",
    cx: 5.781,
    cy: 5.781,
    r: 5.781,
    transform: "translate(43.958 14.982)",
    fill: "#cf2e27"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_264",
    "data-name": "Ellipse 264",
    cx: 4.688,
    cy: 4.688,
    r: 4.688,
    transform: "translate(52.083 19.044)",
    fill: "#cf2e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1454",
    "data-name": "Path 1454",
    d: "M158.471,124.918a4.033,4.033,0,1,1-4.033-4.034A4.033,4.033,0,0,1,158.471,124.918Z",
    transform: "translate(-126.903 -101.996)",
    fill: "#cf2e27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1455",
    "data-name": "Path 1455",
    d: "M138.787,156.809a3.227,3.227,0,1,1-3.227-3.227A3.227,3.227,0,0,1,138.787,156.809Z",
    transform: "translate(-111.657 -129.585)",
    fill: "#cf2e27"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar16);
export default __webpack_public_path__ + "static/media/avatar16.cde8b1c8c14273ae1bb6bf4797652c7c.svg";
export { ForwardRef as ReactComponent };